export default __webpack_public_path__ + "static/media/taiken.88e8b8f2.png";